/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class LocationUrls {
    public static readonly ACCOUNT_SCREEN = '/main-settings/account';

    public static readonly CLOUD_DVR_HELP_SCREEN = '/main-settings/help/dvr-service';

    public static readonly PC_HELP_SCREEN = '/main-settings/help/parental-help';

    public static readonly COLLECTION_SCREEN = '/collection';

    public static readonly EMPTY_GUIDE = '/guide/empty';

    public static readonly FILTERED_GUIDE = '/filtered-guide';

    public static readonly EMPTY_FILTERED_GUIDE = '/filtered-guide/empty';

    public static readonly ERROR_SCREEN = '/error';

    public static readonly GALLERY_SCREEN = '/gallery';

    public static readonly GUIDE = '/guide';

    public static readonly HELP_SCREEN = '/main-settings/help';

    public static readonly INFO_SCREEN = '/main-settings/info';

    public static readonly MENU_LANGUAGE_SCREEN = 'main-settings/user-preferences/menu-language';

    public static readonly MAIN_SETTINGS_SCREEN = '/main-settings';

    public static readonly MAIN_SETTINGS = {
        ACCOUNT: 'account',
        CLOUD_DVR_HELP_SCREEN: 'help/dvr-service',
        HELP_SCREEN: 'help',
        INFO: 'info',
        MANAGE: 'manage',
        MENU_LANGUAGE_SCREEN: 'user-preferences/menu-language',
        MY_SHOWS_OPTIONS_MENU_SCREEN: 'user-preferences/my-shows-options',
        ONEPASS_MANAGER_SETTINGS_SCREEN_OLD_REMOVE_IN_KST_14345: 'onepass-manager',
        ONEPASS_MANAGER_SETTINGS_SCREEN: 'manage/onepass-manager',
        TODO_LIST_SCREEN: 'manage/todo-list',
        EMPTY_TODO_LIST_SCREEN: 'manage/todo-list/empty',
        RECORDING_ACTIVITY_SCREEN: 'manage/recording-activity',
        EMPTY_RECORDING_ACTIVITY_SCREEN: 'manage/recording-activity/empty',
        ONEPASS_AND_RECORDINGS_OPTIONS_MENU_SCREEN:
            'user-preferences/onepass-and-recordings-options',
        USER_PREFERENCES_SCREEN: 'user-preferences',
        USER_PREF_VIDEO_WINDOW_SCREEN: 'user-preferences/videowindow',
        PC_SET_RATING_LIMITS: 'parental-controls/set-rating-limits',
        PC_HIDE_ADULT_CONTENT_SCREEN: 'parental-controls/hide-adult-content',
        PC_SCREEN: 'parental-controls',
        PC_HELP_SCREEN: 'help/parental-help',
        PC_HELP_CONTROLS_ON_OFF: 'help/parental-help/turning-controls',
        PC_HELP_LOCKS_LIMITS: 'help/parental-help/locks-limits',
        PC_HELP_FORGOTTEN_PIN: 'help/parental-help/forgotten-pin',
    };

    public static readonly MY_SHOWS_OPTIONS_MENU_SCREEN =
        '/main-settings/user-preferences/my-shows-options';

    public static readonly MY_SHOWS_SCREEN = '/myshows';

    public static readonly LIST_VIEW_SCREEN = '/list-view-screen';

    public static readonly ONEPASS_MANAGER_SETTINGS_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.ONEPASS_MANAGER_SETTINGS_SCREEN}`;

    public static readonly ONEPASS_MANAGER_SETTINGS_SCREEN_OLD_REMOVE_IN_KST_14345 = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.ONEPASS_MANAGER_SETTINGS_SCREEN_OLD_REMOVE_IN_KST_14345}`;

    public static readonly TODO_LIST_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.TODO_LIST_SCREEN}`;

    public static readonly EMPTY_TODO_LIST_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.TODO_LIST_SCREEN}/empty`;

    public static readonly RECORDING_ACTIVITY_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.RECORDING_ACTIVITY_SCREEN}`;

    public static readonly EMPTY_RECORDING_ACTIVITY_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.EMPTY_RECORDING_ACTIVITY_SCREEN}`;

    public static readonly ONEPASS_AND_RECORDINGS_OPTIONS_MENU_SCREEN =
        '/main-settings/user-preferences/onepass-and-recordings-options';

    public static readonly PC_HIDE_ADULT_CONTENT_SCREEN =
        '/main-settings/parental-controls/hide-adult-content';

    public static readonly PC_SCREEN = '/main-settings/parental-controls';

    public static readonly PC_SET_RATING_LIMITS =
        '/main-settings/parental-controls/set-rating-limits';

    public static readonly PC_HELP_CONTROLS_ON_OFF =
        '/main-settings/help/parental-help/turning-controls';

    public static readonly PC_HELP_LOCKS_LIMITS = '/main-settings/help/parental-help/locks-limits';

    public static readonly PC_HELP_FORGOTTEN_PIN =
        '/main-settings/help/parental-help/forgotten-pin';

    public static readonly MANAGE_SCREEN = `${LocationUrls.MAIN_SETTINGS_SCREEN}/${LocationUrls.MAIN_SETTINGS.MANAGE}`;

    public static readonly PROGRAM_SCREEN = '/program';

    public static readonly SIGN_IN_SCREEN = '/signin';

    public static readonly SOS_SCREEN = '/sos';

    public static readonly SPLASH_SCREEN = '/';

    public static readonly USER_PREFERENCES_SCREEN = '/main-settings/user-preferences';

    public static readonly USER_PREF_VIDEO_WINDOW_SCREEN =
        '/main-settings/user-preferences/videowindow';

    public static readonly VIDEO_PLAYER = '/video-player';

    public static readonly VOD_BROWSE_MAIN_SCREEN = '/vod-browse-main';
}
